module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av320-263abc8213c26bcb6a92c41fb7172b93.jpg";